import { Controller } from "@hotwired/stimulus"

// Handles metric dimension filter dropdowns (account, parent, subject).
// Listens for change events on <select> elements within the controller scope,
// reads the dimension name from data-metric-dimension, and navigates.
export default class extends Controller {
  filter(event) {
    const select = event.target.closest("[data-metric-dimension]")
    if (!select) return

    const dimension = select.dataset.metricDimension
    const value = select.value
    const url = new URL(window.location.href)

    if (dimension === "account") {
      // Account is the top-level cascade — changing it clears child filters.
      if (value === "") {
        url.searchParams.delete("account_id")
      } else {
        url.searchParams.set("account_id", value)
      }
      url.searchParams.delete("parent_type")
      url.searchParams.delete("parent_id")
      url.searchParams.delete("subject_type")
      url.searchParams.delete("subject_id")
    } else {
      if (value === "") {
        url.searchParams.delete(dimension + "_type")
        url.searchParams.delete(dimension + "_id")
      } else {
        const [type, id] = value.split(":")
        url.searchParams.set(dimension + "_type", type)
        url.searchParams.set(dimension + "_id", id)
      }
    }

    window.location.href = url.toString()
  }
}
